import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, finalize, tap } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { GerarIssCacheService } from '../modules/nota-fiscal/services/gerar-iss-cache.service';


@Injectable({
  providedIn: 'root'
})
export class IssqnInterceptorService implements HttpInterceptor{

  constructor(private gerarIssCache: GerarIssCacheService) { }
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable< HttpEvent<any> > {

     
    if(req.url.includes(environment.urls.consultaCep) || req.url.includes(environment.urls.php.previaGuia)
    || req.url.includes(environment.urls.php.gerarGuia) || req.url.includes(environment.urls.php.baixarGuia)) {
      req = req.clone({
        headers: new HttpHeaders()
      });
    } 
    
    if(req.url.includes(environment.urls.php.previaGuia) || req.url.includes(environment.urls.php.gerarGuia)) {
      req = req.clone({
        withCredentials: true
      });
    }

    if(req.url.includes(environment.urls.php.gerarGuia)) {
      req = req.clone({
        withCredentials: true,
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded'
        })
      });
    }

    return next.handle(req).pipe(
      tap(
        event => {
          if (event instanceof HttpResponse) {
            
          }
        },
        err => {

        }
      ),
      finalize(() => {
      })
    );
  }
}
